/* MyBauer 2D customizer — Sentry error tracking.
   Loaded from mybauer_sentry_snippet.liquid (via cql-head-content), blocking,
   before the mybauer.bauer.com bundle in the page body. ES5 only. Must be
   safe to run twice and safe when the Sentry CDN is blocked. */
(function () {
  'use strict';

  if (window.MyBauerSentry) return;

  if (!window.Sentry || typeof window.Sentry.init !== 'function') {
    window.MyBauerSentry = { enabled: false, capture: function () {} };
    return;
  }


  var cfg = window.myBauerSentryConfig || {};
  // Public DSN — mybauer-2d-customizer project.
  var DSN = cfg.dsn || 'https://efb243a84ded2a3d8689ca9633e5607c@o4507419639021568.ingest.us.sentry.io/4511965077700608';

  if (DSN.indexOf('http') !== 0) {
    window.MyBauerSentry = { enabled: false, capture: function () {} };
    return;
  }

  var MB_URL_RE = /mybauer\.bauer\.com|mybauer_sentry\.js/;
  var CART_ADD_RE = /\/cart\/add(\.js)?(\?|$)/;

  function shopDomain() {
    return cfg.shop || (window.Shopify && window.Shopify.shop) || '';
  }

  function myBauerEl() {
    return document.querySelector('.my-bauer');
  }

  function attr(name) {
    var el = myBauerEl();
    return (el && el.getAttribute(name)) || '';
  }

  function regionFallback() {
    var s = shopDomain() + ' ' + (window.location.hostname || '');
    if (/bauer-ca|bauer-hockey-ca|(^|\s|\.)ca\./.test(s)) return 'ca';
    if (/bauer-se|bauer-hockey-se|(^|\s|\.)se\./.test(s)) return 'se';
    if (/bauer-fi|(^|\s|\.)fi\./.test(s)) return 'fi';
    if (/bauer-dk|(^|\s|\.)dk\./.test(s)) return 'dk';
    if (/bauer-no|(^|\s|\.)no\./.test(s)) return 'no';
    return 'us';
  }

  function getRegion() {
    return cfg.region || regionFallback();
  }

  function getProduct() {
    return cfg.stick_product || 'unknown';
  }

  // theme.role from Liquid (myBauerSentryConfig) — Shopify.theme is injected
  // in content_for_header AFTER this script runs, so the client fallback alone
  // mis-tags preview themes on live stores as production.
  function themeRole() {
    if (cfg.theme_role) return cfg.theme_role;
    try { return (window.Shopify && Shopify.theme && Shopify.theme.role) || ''; }
    catch (e) { return ''; }
  }

  function themeId() {
    if (cfg.theme_id) return String(cfg.theme_id);
    try { return (window.Shopify && Shopify.theme && Shopify.theme.id) || ''; }
    catch (e) { return ''; }
  }

  function themeName() {
    if (cfg.theme_name) return cfg.theme_name;
    try { return (window.Shopify && Shopify.theme && Shopify.theme.name) || ''; }
    catch (e) { return ''; }
  }

  function environment() {
    if (/-dev\./.test(shopDomain())) return 'staging';
    var role = themeRole();
    if (role && role !== 'main') return 'production-draft';
    return 'production';
  }

  function isMyBauerUrl(url) {
    return !!url && MB_URL_RE.test(String(url));
  }

  function stackTouchesMyBauer(event) {
    try {
      var values = (event.exception && event.exception.values) || [];
      for (var i = 0; i < values.length; i++) {
        var frames = (values[i].stacktrace && values[i].stacktrace.frames) || [];
        for (var j = 0; j < frames.length; j++) {
          if (isMyBauerUrl(frames[j].filename || frames[j].abs_path)) return true;
        }
      }
    } catch (e) {}
    return false;
  }

  Sentry.init({
    dsn: DSN,
    environment: environment(),
    sampleRate: 1.0,
    maxBreadcrumbs: 50,
    autoSessionTracking: false,
    integrations: [
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [[400, 599]],
        failedRequestTargets: [
          /mybauer\.bauer\.com/,
          /\/cart\/add(\.js)?/
        ]
      })
    ],
    ignoreErrors: [
      /ResizeObserver loop/i,
      /Non-Error promise rejection captured/i,
      'Script error.',
      /globalThis is not defined/i,
      /instantSearchSDKJSBridgeClearHighlight/i,
      /window\.webkit\.messageHandlers/i
    ],
    denyUrls: [
      /googletagmanager\.com/,
      /google-analytics\.com/,
      /doubleclick\.net/,
      /static\.klaviyo\.com/,
      /klaviyo\.com/,
      /connect\.facebook\.net/,
      /snap\.licdn\.com/,
      /bat\.bing\.com/,
      /^chrome-extension:\/\//,
      /^moz-extension:\/\//,
      /^safari(-web)?-extension:\/\//
    ],
    beforeSend: function (event) {
      event.tags = event.tags || {};

      event.tags.customizer_stack = event.tags.customizer_stack || 'mybauer_2d';
      event.tags.region = event.tags.region || getRegion();
      event.tags.product = event.tags.product || getProduct();
      event.tags.locale = event.tags.locale || attr('data-locale') || cfg.locale || '';
      event.tags.shop = event.tags.shop || shopDomain();
      event.tags.template = event.tags.template || cfg.template || '';
      event.tags.theme_role = event.tags.theme_role || themeRole() || 'unknown';
      event.tags.theme_id = event.tags.theme_id || String(themeId() || '');
      event.tags.theme_name = event.tags.theme_name || themeName();
      event.tags.surface = event.tags.surface || 'storefront';

      var isHttpClient = false;
      var failedUrl = '';
      try {
        var v0 = event.exception && event.exception.values && event.exception.values[0];
        if (v0 && /^HTTP Client Error/.test(v0.value || '')) {
          isHttpClient = true;
          failedUrl = (event.request && event.request.url) || (v0.value.split(' ').pop() || '');
        }
      } catch (e) {}

      if (!event.tags.mb_error_type && isHttpClient) {
        event.tags.mb_error_type = CART_ADD_RE.test(failedUrl) ? 'add_to_cart' : 'asset_load';
      }

      var mbRelated = !!event.tags.mb_error_type || isMyBauerUrl(failedUrl) || stackTouchesMyBauer(event);
      event.tags.mb_related = mbRelated ? 'true' : 'false';

      return event;
    }
  });

  window.MyBauerSentry = {
    enabled: true,
    capture: function (message, tags, extra) {
      try {
        Sentry.withScope(function (scope) {
          var k;
          if (tags) { for (k in tags) { if (tags.hasOwnProperty(k)) scope.setTag(k, tags[k]); } }
          scope.setTag('customizer_stack', 'mybauer_2d');
          scope.setTag('region', getRegion());
          scope.setTag('product', getProduct());
          if (extra) { for (k in extra) { if (extra.hasOwnProperty(k)) scope.setExtra(k, extra[k]); } }
          scope.setLevel('error');
          if (tags && tags.mb_error_type) {
            scope.setFingerprint(['mybauer', tags.mb_error_type, message]);
          }
          Sentry.captureMessage(message);
        });
      } catch (e) {}
    }
  };

  window.addEventListener('error', function (e) {
    var t = e.target || e.srcElement;
    if (!t || !t.tagName) return;
    var tag = t.tagName.toLowerCase();
    if (tag !== 'script' && tag !== 'link' && tag !== 'img') return;
    var url = t.src || t.href || '';
    if (!isMyBauerUrl(url)) return;
    window.MyBauerSentry.capture('MyBauer asset failed to load: <' + tag + '>', {
      mb_error_type: 'asset_load'
    }, { asset_url: url });
  }, true);

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = '';
      try { url = (input && input.url) || String(input || ''); } catch (e) {}
      var result = origFetch.apply(this || window, arguments);

      if (isMyBauerUrl(url) || CART_ADD_RE.test(url)) {
        result = result.then(function (response) {
          if (CART_ADD_RE.test(url) && response && typeof response.clone === 'function') {
            response.clone().json().then(function (body) {
              if (body && ((body.status && body.status >= 400) || (body.description && !body.key))) {
                window.MyBauerSentry.capture('MyBauer add to cart rejected', {
                  mb_error_type: 'add_to_cart'
                }, { response: JSON.stringify(body).slice(0, 2000) });
              }
            }).catch(function () {});
          }
          return response;
        }).catch(function (err) {
          window.MyBauerSentry.capture(
            'MyBauer request failed (CORS/network): ' + url.split('?')[0],
            {
              mb_error_type: CART_ADD_RE.test(url) ? 'add_to_cart' : 'asset_load',
              mb_network_failure: 'true'
            },
            { url: url, error: String(err) }
          );
          throw err;
        });
      }

      return result;
    };
  }
})();
